import React, {useState, useEffect} from 'react';
import { PackageTrackingDetails, RequestChangePostResponse } from '../../../types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import CheckboxContainer from '../Shared/Checkbox/CheckboxContainer';
import AddressComponent from '../Shared/AddressComponent';
import { InputRow, InputLabel, SubmitButton } from './RequestChangeInputs';
import toast from '../../../Scripts/App/displayToastMessage';

interface CancelJobProps {
    packageDetails: PackageTrackingDetails;
};

const CancelJobComponent = ({packageDetails}: CancelJobProps) => {
    const [t] = useTranslation();
    const [isConfirmChecked, setIsConfirmChecked] = useState(false);
    const [validationErrors, setValidationErrors] = useState<{[key: string]: string[]} | undefined>();

    const sendCancelRequest = () => {
        
        const xhr = new XMLHttpRequest();
        const url = `Package/CancelJob`;
        xhr.open('POST', url, true);
        xhr.setRequestHeader('Content-type', 'application/json');
        const data = JSON.stringify({
            TrackingNumber: packageDetails.TrackingNumber,
            JobId: packageDetails.JobId,
            IsDelivery: packageDetails.DeliveryOptions.IsDelivery,
            IsCancelled: isConfirmChecked,
        });

        xhr.onload = () => {
            const response = JSON.parse(xhr.responseText) as RequestChangePostResponse;
            if(response.Success)
            {
                // refresh the page
                window.location.href = `Package/Details?trackingNumber=${packageDetails.TrackingNumber}&message=${t('job_successfully_cancelled')}`;
            }
            else
            {
                setValidationErrors(response.ValidationErrors);
                if(response.Message)
                {
                    toast(response.Message, response.MessageType ?? 'success');
                }
            }
        }

        xhr.send(data);
    };

    return(
        <>
            <InputRow>
                <InputLabel>{t('cancel_job_title')}</InputLabel>
                <div><strong>{t('cancel_job_header').replace('{0}', packageDetails.DeliveryOptions.JobTypeName)}</strong></div>
            </InputRow>
            <InputRow>
                <InputLabel /> {/* Placeholder to fill first column */}
                <AddressComponent address={packageDetails.DeliveryOptions.Address} />
            </InputRow>
            <InputRow>
                <InputLabel /> {/* Placeholder to fill first column */}
                <CheckboxContainer 
                    label={<strong>{t('cancel_job_model_is_cancelled')}</strong>} 
                    checked={isConfirmChecked} 
                    handleClick={setIsConfirmChecked} 
                />
            </InputRow>
            
            {isConfirmChecked &&
                <SubmitButton handleClick={sendCancelRequest} />}
        </>
    );
};

export default CancelJobComponent;